/** Persists browser-created Push API subscriptions under authenticated RLS. */
import type { SupabaseClient } from '@supabase/supabase-js';

import type { Database, PushSubscriptionInsert } from '../../database.types.js';
import type { PushSubscriptionRepository, StoredPushSubscription } from '../pushNotifications.js';

const toRow = (subscription: StoredPushSubscription): PushSubscriptionInsert => ({
  endpoint: subscription.endpoint,
  expiration_time: subscription.expirationTime,
  p256dh: subscription.keys.p256dh,
  auth: subscription.keys.auth,
});

export const createSupabasePushSubscriptionRepository = (
  client: SupabaseClient<Database>,
): PushSubscriptionRepository => ({
  save: async (subscription) => {
    const { error } = await client
      .from('push_subscriptions')
      .upsert(toRow(subscription), { onConflict: 'endpoint' });
    if (error) throw error;
  },

  remove: async (endpoint) => {
    const { error } = await client.from('push_subscriptions').delete().eq('endpoint', endpoint);
    if (error) throw error;
  },
});
